export enum PackagesEnum {
    Business = 'business',
    BusinessPlus = 'business+',
    Free = 'free',
    Ocr = 'ocr',
    Premium = 'premium',
    Trial = 'trial',
}